<template>
  <div class="contentBox">
    <div class="container">
      <div class="article">
        <p class="page-title">Yêu cầu hủy tài khoản game</p>
        <p class="strong">
          Vui lòng đọc kỹ các điều khoản về việc hủy tài khoản game và tích chọn
          vào ô xác nhận ở cuối trang.
        </p>
        <p class="text">Điều kiện hủy tài khoản game</p>
        <p class="text">
          Người chơi thân mến, trước khi bạn gửi yêu cầu hoặc tiếp tục yêu cầu
          hủy tài khoản game, để đảm bảo an toàn tài khoản và các quyền lợi liên
          quan, bạn cần tự kiểm tra, đảm bảo và cam kết rằng tài khoản bạn yêu
          cầu hủy đáp ứng đầy đủ các điều kiện dưới đây, bao gồm nhưng không
          giới hạn:
        </p>
        <p class="title">
          1. Tài khoản game thuộc quyền sở hữu hợp pháp của chính bạn và được
          bạn đăng nhập, đồng thời phù hợp với quy định về tài khoản trong “Thỏa
          thuận người dùng” và các quy định liên quan.
        </p>
        <div class="height27"></div>
        <p class="title">
          2. Tài khoản game đang ở trạng thái an toàn, hoạt động bình thường:
        </p>
        <p class="text">
          Tài khoản bình thường, không bị khóa, không có nguy cơ bị đánh cắp;
          không bị khóa hoặc đóng băng trong vòng 14 ngày gần nhất; không có các
          thao tác nhạy cảm như đổi thiết bị, đổi mật khẩu, chuyển tài khoản
          trong vòng 14 ngày gần nhất.
        </p>
        <p class="title">
          3. Tài sản trong tài khoản game đã được thanh toán hoặc xử lý hợp lý,
        </p>
        <p class="text">
          Bao gồm nhưng không giới hạn: vé, kim cương, số lượt chiến đấu, đạo
          cụ, quyền lợi gói đăng ký,... Ngoài ra, không có yêu cầu hoàn tiền
          chưa được xử lý. Vui lòng tự bảo quản tài sản trong game, nếu không xử
          lý khi hủy tài khoản, sẽ được xem là tự từ bỏ những tài sản trong game
          này.
        </p>
        <p class="title">4. Tài khoản game không có đơn hàng chưa hoàn tất,</p>
        <p class="text">
          Bao gồm nhưng không giới hạn: nạp kim cương, mua gói, gói đăng ký,...
        </p>
        <p class="title">5. Tài khoản không có quan hệ xã hội nào,</p>
        <p class="text">
          Bao gồm nhưng không giới hạn: đội nhóm, bang hội, quan hệ sư đồ,...
        </p>
        <p class="title">
          6. Tài khoản không liên quan đến bất kỳ tranh chấp nào,
        </p>
        <p class="text">
          Bao gồm tố cáo, bị tố cáo, bị điều tra bởi cơ quan nhà nước, trọng
          tài, kiện tụng và các tranh chấp khác.
        </p>
        <p class="title">7. Các điều kiện khác do Mgol công bố chính thức.</p>
      </div>
      <div class="btn-box">
        <div class="rule-check">
          <div class="checkbox" @click="handleCheck()">
            <img
              src="../../assets/img/deleteAccount/circle_s.png"
              alt=""
              class="check"
              :style="{ display: isClick ? `block` : 'none' }"
            />
          </div>
          <p class="rule">
            I have carefully read and met the conditions for account
            cancellation.
          </p>
        </div>
        <div
          class="btn unactive"
          :class="isClick ? 'active' : ''"
          @click="handleConfirm"
        >
          Next
        </div>
      </div>
    </div>
    <!---->
  </div>
</template>

<script>
export default {
  name: "",
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
      isClick: false,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    handleCheck() {
      this.isClick = !this.isClick;
    },
    handleConfirm() {
      if (!this.isClick) {
        return;
      }
      this.$router.push("/main/deletion/regulation2");
    },
  },
};
</script>


<style scoped lang="scss">
@import "./css/index.css";
</style>
